import { motion } from 'framer-motion';
import { styled } from 'styled-components';

import { fadeTransition, FadeVariant, fadeVariants } from '@pkg/motion';
import { styledReset } from '@pkg/primitives';

import { tokens } from './YatsSection.tokens';

export const Section = styled(motion.div)`
    // This wrapper - or any other parent of the <ul /> - cannot be
    // positioned (have a stacking context) or else offsetTop cannot
    // be captured within useVurtis().
`;

// TODO: `LoadingGridAnimation` uses `div` but should use `li`.
export const YatList = styled.ul`
    ${styledReset.list};
    --item-min-width: ${tokens.item.minWidth.mobile}px;

    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(var(--item-min-width), 1fr));
    gap: ${tokens.list.gap}px;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        --item-min-width: ${tokens.item.minWidth.tablet}px;
    }
`;

export const YatItem = styled(motion.li).attrs({
    variants: fadeVariants,
    initial: FadeVariant.Hidden,
    animate: FadeVariant.Show,
    exit: FadeVariant.Hidden,
    transition: fadeTransition,
})`
    // Avoid using AnimatePresence for the exit animation.
    // We shouldn't really need to support "exit", since that
    // animation would happen offscreen. "Entrance" animation
    // works without AnimatePresence.

    // TODO: Required to target the <YatCard /> within.
    // Since not all YatCards contain equivalent content, some cards
    // could be taller/shorter than others. This is an issue we need to address.
    > div {
        height: 100%;
    }
`;
